import script from "./works.vue?vue&type=script&setup=true&lang=js"
export * from "./works.vue?vue&type=script&setup=true&lang=js"

import "./works.vue?vue&type=style&index=0&id=75fde0de&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75fde0de"]])

export default __exports__